export const calculateValueWithVAT = (value, vat, vatInCompanyIsOn) => {
  if (vatInCompanyIsOn) {
    return vat ? parseFloat((value * (1 + vat / 100)).toFixed(2)) : value;
  }

  return value;
};
